<template>
    <NuxtLink
        :to="
            $localePath(
                `/${news?.type === 'news' ? 'news' : 'awards'}/${news?.id}`,
            )
        "
        :class="
            twMerge(
                'border-news slt-flex-center overflow-hidden rounded-[var(--card-radius)] bg-base-white text-base-black shadow-custom [--card-radius:1rem]',
                variant === 'main' &&
                    'flex-col sm:grid sm:grid-cols-2 sm:flex-row',
                variant === 'sub' && 'flex-row sm:flex-col',
                variant === 'normal' && 'flex-row',
            )
        "
        v-sendGAsignal="{
            event_category: news?.type === 'news' ? 'news' : 'awards',
            event_label: `${news?.id}-${news?.meta_box?.article?.headline}`,
        }"
    >
        <div
            :class="
                twMerge(
                    'relative flex-shrink-0 overflow-hidden rounded-[var(--card-radius)]',
                    variant === 'main' &&
                        'h-0 w-full pt-[75%] sm:h-full sm:w-full sm:pt-[unset]',
                    variant === 'sub' &&
                        'h-[calc(160px*.8875)] w-40 sm:h-0 sm:w-full sm:pt-[53.4%] lg:pt-[53.23%]',
                    variant === 'normal' &&
                        'h-[calc(160px*.8875)] w-40 sm:h-[calc(264px*.8875)] sm:w-[264px] lg:h-[calc(280px*.8875)] lg:w-[280px]',
                )
            "
        >
            <img
                v-if="news?.featured_media"
                :src="`${news?.featured_media?.source_url}`"
                :alt="news?.featured_media?.alt_text"
                :width="news?.featured_media?.media_details?.width"
                :height="news?.featured_media?.media_details?.height"
                class="absolute inset-0 h-full w-full object-cover"
            />
        </div>
        <div
            :class="
                twMerge(
                    'relative flex-1',
                    variant === 'main' &&
                        'w-full px-4 pb-20 pt-4 sm:h-full sm:px-6 sm:pb-[88px] sm:pt-6 lg:px-12 lg:pb-[104px] lg:pt-10',
                    variant === 'sub' &&
                        'p-4 pb-5 sm:pb-[72px] lg:px-8 lg:pb-[88px] lg:pt-8',
                    variant === 'normal' &&
                        'p-4 pb-5 sm:px-6 sm:pb-10 sm:pt-6 lg:px-8 lg:pb-9 lg:pt-8',
                )
            "
        >
            <div class="flex items-center justify-between">
                <!-- TEMP: 一篇新聞只能顯示一個分類設計(無分類則顯示預設值) -->
                <AtomsTag
                    :html="
                        news?.type === 'news'
                            ? news['news-category'][0] ||
                              $t('news.post.type.news')
                            : news['award-category'][0] ||
                              $t('news.post.type.awards')
                    "
                ></AtomsTag>
                <AtomsBody1
                    lang="en"
                    class="hidden text-base-black-60 sm:block"
                    >{{ formatDate(news?.date) }}</AtomsBody1
                >
            </div>
            <div
                :class="
                    twMerge(
                        'mt-4 flex flex-col',
                        variant === 'main' && 'sm:gap-4',
                        variant === 'normal' && 'sm:gap-6',
                    )
                "
            >
                <AtomsH3
                    v-if="
                        variant === 'main' &&
                        shouldRender(news?.meta_box?.customTitle)
                    "
                >
                    {{ renderLines(news?.meta_box?.customTitle) }}
                </AtomsH3>
                <AtomsH4
                    class="line-clamp-3 sm:line-clamp-2"
                    v-else-if="shouldRender(news?.meta_box?.customTitle)"
                    v-html="
                        search
                            ? highlightText(
                                  renderLines(news?.meta_box?.customTitle),
                                  search,
                              )
                            : renderLines(news?.meta_box?.customTitle)
                    "
                />
                <p
                    :class="
                        twMerge(
                            'sm:display-[unset] hidden text-base-black-60',
                            variant === 'main'
                                ? 'sm:line-clamp-3'
                                : 'sm:line-clamp-2',
                        )
                    "
                    v-if="
                        (variant === 'main' || variant === 'normal') &&
                        shouldRender(news?.meta_box?.customDescription)
                    "
                    v-html="
                        search
                            ? highlightText(
                                  renderLines(
                                      news?.meta_box?.customDescription,
                                  ),
                                  search,
                              )
                            : renderLines(news?.meta_box?.customDescription)
                    "
                />
            </div>
            <SvgArrowForward40
                :class="
                    twMerge(
                        'absolute bottom-4  right-4 !h-10 !w-10 sm:bottom-6 sm:right-6 lg:bottom-10 lg:right-12',
                        variant === 'sub' &&
                            'hidden sm:bottom-4 sm:right-4 sm:block lg:bottom-8 lg:right-8',
                        variant === 'normal' && 'hidden',
                    )
                "
            />
        </div>
    </NuxtLink>
</template>

<script setup>
import { twMerge } from "tailwind-merge";
import {
    renderLines,
    shouldRender,
    formatDate,
    highlightText,
} from "~/lib/utils";
const {
    variant = "normal",
    news,
    page,
} = defineProps({
    page: {
        type: String,
        default: "news",
    },
    variant: {
        type: String,
        default: "normal",
        validator: (value) => ["main", "sub", "normal"].includes(value),
    },
    news: {
        type: Object,
        required: true,
    },
    search: {
        type: String,
        default: "",
    },
});
</script>
